import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useData } from '@hooks/useData';

export interface FinancingLogoProps {
    src?: string | null;
}

// TODO: Atualizar storybook.
export const FinancingLogo: FC<FinancingLogoProps> = ({ src }) => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        financingLogoAlt: t('financing-logo.alt'),
    };

    const finalSrc = src || allSettings?.data?.financingLogo?.src;

    return (
        <>
            {finalSrc && (
                <div className="align-self-center align-content-around py-4 py-lg-3 h-100">
                    <div className="d-flex justify-content-center h-100">
                        <img
                            style={{ height: '35px', alignSelf: 'center', maxWidth: '100%' }}
                            src={finalSrc}
                            alt={translations.financingLogoAlt}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
